<template>
  <li class="block-item" @click.prevent="toggleTopics" @mouseenter="toggleTopics">
    <a href class="block-item-link" @click.prevent="toggleTopics">
      <div class="section-image">
        <img :src="getImage(categoria.image, site)" :alt="categoria.title" class="block-image" />
      </div>
      <h4 class="block-item-title">{{categoria.title}}</h4>
    </a>
    <div v-if="showTopics" class="main-articles">
      <ul>
        <li
          v-for="(topico, index) in categoria.topicos.slice(0,3)"
          :key="index"
          :title="topico.title"
        >
          <router-link
            :to="`/category/${categoryId}/article/${index}`"
            class="main-articles-three-items"
          >{{topico.title}}</router-link>
        </li>
      </ul>
      <router-link :to="`/category/${categoryId}/`" class="mt-auto">VER TUDO</router-link>
    </div>
  </li>
</template>

<script>
export default {
  name: "BlockItem",
  props: {
    categoria: Object,
    site: String,
    categoryId: Number
  },
  data() {
  return {
    showTopics: false,
    isMobile: false
    }
  },
  mounted() {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    mediaQuery.addListener(handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);

    function handleMediaQueryChange(mediaQuery) {
      if (mediaQuery.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  methods: {
    getImage(image, site) {
      const icons = require.context(
        "../assets/",
        true,
        /\.(png|jpe?g|gif|svg)(\?.*)?$/
      );
      return image ? icons(`./${site}/${image}`) : "";
    },
    toggleTopics() {
      if (this.isMobile) {
        this.showTopics = !this.showTopics;
      } else {
        this.showTopics = true; 
      }
    }
  }
};
</script>

<style lang="scss">

.block-item {
  background-color: #ffffff;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 1);
  display: flex;
  flex: 1 0 220px;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 4%;
  max-width: 48%;
  width: 100%;
  height: 280px;
  text-align: center;
  transition: all 300ms ease;
}
.block-item-title {
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  text-transform: uppercase;
  margin: 0;
}

.block-message {
  margin: -1rem 0 0 1rem;
  font-weight: 400;
  font-size: 13px;
}

.block-item-link {
  height: 220px;
  padding: 20px 30px;
  cursor: default;
}

.block-item-link > * {
  cursor: pointer;
}

.section-image {
  width: 100%;
  height: 120px;
}

a {
  color: rgba(0, 0, 0, 1);
  text-decoration: none;
}

.main-articles {
  position: absolute;
  width: 100%;
  max-width: 170px;
  height: 280px;
  /* margin-top: 20px; */
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 0s, opacity 0.5s linear;
  transition: visibility 0s, opacity 0.5s linear;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.main-articles ul {
  list-style: none;
  margin: 0;
  padding: 0;
  & li a {
    font-weight: 400;
    color: #999;
    font-size: 11px;
  }
  & li {
    padding: 10px;
    cursor: pointer;
    &:hover a,
    & li:focus a,
    & li:active a {
      text-decoration: underline;
    }
  }
}

.main-articles-three-items {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 48px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.main-articles > a {
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
  text-transform: uppercase;
}
.block-item:hover > a {
  visibility: hidden;
  transition: visibility 0s, opacity 0.5s linear;
}
.block-item:hover > div {
  visibility: visible;
  opacity: 1;
}

@media (min-width:801px)  {
  .main-articles {
    max-width: 220px;
  }
 }

/* Breakpoint mobile */
/* mobile L */
@media (max-width: 594px) and (min-width: 412px) {
  .block-item-link {
    padding: 20px 10px;
    height: 151px;
  }
}
/*mobile M*/

/*mobile S*/
</style>